import { useContext, useEffect } from "react";
import { Button } from "components/button";
import { Header } from "components/header";
import AuthContext from "contexts/AuthContext";
import { useTranslation } from "react-i18next";
// import { LOCALE_NAME, STATE_NAME, COUNTRY_NAME } from "consts/query-params";
import { Link } from "react-router-dom";
// import { useCurrentLocation } from "lib/utils";
import ScrollToTop from "components/scroll-to-top";
import { Footer } from "components/footer/footer";
// import ImpressumFooter from "components/footer-impressum";

export default function PrivacyPolicyPage() {
  //auth
  const { user } = useContext(AuthContext);

  //translation
  const { t } = useTranslation();

  // Get location settings
  // const { location: currentLocation } = useCurrentLocation();

  // const CtaButton = ({ className }) => {
  //   return (
  //     <Button
  //       href={`${t("urls.trade_in_weight")}`}
  //       queryParams={{
  //         [LOCALE_NAME]: currentLocation.locale,
  //         [STATE_NAME]: currentLocation.state,
  //         [COUNTRY_NAME]: currentLocation.country,
  //       }}
  //       className={className}
  //     >
  //       {t("landing.button_start_new")}
  //     </Button>
  //   );
  // };

  // minimise Intercom messenger
  useEffect(() => {
    if (window.Intercom) {
      window.Intercom("hide");
    }
  }, []);

  return (
    <div className="min-h-screen w-screen">
      <Header classNames="bg-yellow border-none">
        <div className="flex gap-large">
          {/* <CtaButton className="hidden md:block" /> */}
          <Button
            href={user ? `${t("urls.my_trade_ins")}` : `${t("urls.login")}`}
            variant="secondary"
          >
            {user
              ? t("landing.button_my_trade_ins")
              : t("landing.button_sign_in")}
          </Button>
        </div>
      </Header>
      <ScrollToTop />
      <div className="w-full px-8 container mx-auto mt-16 mb-16">
        <div className="max-w-prose mx-auto">
          <h1 className="text-3xl font-bold mb-8">
            LEGO® Brick Take Back Program Privacy Policy
          </h1>

          <p className="mb-6">Last modified: 14th July 2025</p>

          <p className="mb-6">
            The LEGO Group ("<strong>LEGO</strong>") offers the LEGO® Brick
            Take Back Program ("<strong>Program</strong>") to our customers with
            the help of our partner, Pentatonic Ltd. ("
            <strong>Pentatonic</strong>"), who operates the Program for and on
            behalf of LEGO. This LEGO® Brick Take Back Privacy Policy (the "
            <strong>Program Privacy Policy</strong>"), describes how LEGO and
            Pentatonic (who together may be referred to as "we" or "us")
            collect, use, disclose and otherwise process personal data related
            to the Program and the rights and choices individuals have regarding
            their personal data.
          </p>

          <p className="mb-6">
            For more information about LEGO's privacy practices, please review
            the{" "}
            <a
              href="https://www.lego.com/en-us/legal/notices-and-policies/privacy-policy?locale=en-us"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 underline"
            >
              LEGO Privacy Policy
            </a>{" "}
            and, if you are a California resident, please also review{" "}
            <a
              href="https://www.lego.com/cdn/cs/legal/assets/blted9652e4eb78b865/LEGO_CCPA_Nov_10.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 underline"
            >
              IMPORTANT ADDITIONAL INFORMATION FOR CALIFORNIA RESIDENTS
            </a>
            , for additional information about our information practices and
            your California privacy rights.
          </p>

          <h2 className="text-2xl font-semibold mb-4">
            1. BACKGROUND AND SCOPE
          </h2>

          <h3 className="text-xl font-semibold mb-2">About the Program:</h3>
          <p className="mb-6">
            Subject to the{" "}
            <a
              href="https://legobricktakeback.com/en-US/termsandconditions"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 underline"
            >
              Program Terms & Conditions
            </a>
            , LEGO offers qualifying consumers and other (non-business)
            customers in the United States the opportunity to 'trade-in'
            eligible LEGO® bricks and related items in exchange for LEGO®
            e-Gift cards (referred to as a "<strong>Trade In</strong>" or "
            <strong>Brick Trade In</strong>"). Customers may initiate a Trade In
            online (at{" "}
            <a
              href="https://legobricktakeback.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 underline"
            >
              www.LEGOBrickTakeBack.com
            </a>
            ) or at Program kiosks (each a "<strong>Kiosk</strong>"), located in
            participating stores (each a "<strong>Store</strong>"), and may be
            able to submit Trade Ins:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li>By Mail</li>
            <li>By Store Drop Off (at participating Stores only)</li>
            <li>
              Using Program Kiosks (prior appointment required, at participating
              Stores only)
            </li>
          </ul>

          <h3 className="text-xl font-semibold mb-2">
            Scope of this Privacy Policy:
          </h3>
          <p className="mb-6">
            This Program Privacy Policy applies to collection, use, disclosure
            and other processing of personal data by LEGO, and by Pentatonic and
            other data processors on behalf of LEGO, related to the Program,
            including and related to:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-4">
              The Program website,{" "}
              <a
                href="https://legobricktakeback.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 underline"
              >
                www.LEGOBrickTakeBack.com
              </a>{" "}
              (the "<strong>Site</strong>"), Kiosks, and the features and
              services available on the Site and through the Kiosks
              (collectively, the "<strong>Services</strong>").
            </li>
            <li className="mb-4">
              Your registration for and participation in the Program and use of
              the Services, including your Program account and registration
              information, any Brick Trade Ins that you process or submit
              pursuant to the Program, whether via Mail, Store Drop Off, or
              Kiosk.
            </li>
            <li className="mb-4">
              Surveys, research, and analytics we conduct related to the
              Program, including your participation in and responses to Program
              surveys conducted by a third-party survey administrator on our
              behalf (the "<strong>Survey Administrator</strong>").
            </li>
            <li className="mb-4">
              Your communications and interactions with us related to the
              Program or through the Site and Services.
            </li>
            <li className="mb-4">
              Program-related emails and electronic communications from or on
              behalf of LEGO.
            </li>
            <li className="mb-4">
              Other information related to the performance and use of the
              Program and Services.
            </li>
          </ul>

          <h3 className="text-xl font-semibold mb-2">
            Additional Terms and Policies:
          </h3>
          <p className="mb-6">
            Your access to and use of the Services, participation in the
            Program, and communications or interactions related to the Program,
            as well as any dispute over privacy, is subject to this Program
            Privacy Policy and the{" "}
            <a
              href="https://legobricktakeback.com/en-US/termsandconditions"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 underline"
            >
              Program Terms & Conditions
            </a>
            , which include applicable limitations on damages and the resolution
            of disputes and are incorporated by reference into this Program
            Privacy Policy.
          </p>
          <p className="mb-6">
            If you participate in a Program survey, the survey administrator may
            also provide or offer you the opportunity to receive certain rewards
            or promotions when you complete a Program survey ("
            <strong>Survey Rewards</strong>"), subject to the applicable terms
            and conditions of the Survey Administrator (not the{" "}
            <a
              href="https://legobricktakeback.com/en-US/termsandconditions"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 underline"
            >
              Program Terms & Conditions
            </a>
            ). Your survey responses and any Program information provided to
            Survey Administrator by or on behalf of LEGO are subject to this
            Program Privacy Policy and the disclosures provided when you agree
            to participate in the survey. However, Survey Rewards and related
            eligibility and transaction information is subject to the privacy
            policy and terms and conditions of the Survey Administrator (not
            this Program Privacy Policy or the{" "}
            <a
              href="https://legobricktakeback.com/en-US/termsandconditions"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 underline"
            >
              Program Terms & Conditions
            </a>
            ).
          </p>

          <h2 className="text-2xl font-semibold mb-4">
            2. PERSONAL DATA COLLECTED
          </h2>
          <p className="mb-6">
            The personal data we collect and process depends upon the
            circumstances, including your preferences (e.g., whether you opt in
            to Program marketing emails, opt out of certain cookies on the Site,
            or agree to participate in a survey or focus group), and how you
            participate in the Program (e.g., how you use the Services, submit
            Trade Ins, or communicate and interact with us about the Program).
          </p>

          <h3 className="text-xl font-semibold mb-2">
            A. Personal Data We Collect Directly.
          </h3>
          <p className="mb-4">
            Generally, we may collect the following personal data from you:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-4">
              <span className="underline">
                Account and registration information.
              </span>{" "}
              You can visit the Site without registering. However, to process or
              submit a Brick Trade In or otherwise participate in the Program
              you must register for an account; when you register, we collect
              personal data from you, including name, email address, contact
              information, and other profile information you choose to provide
              (e.g., preferences).
            </li>
            <li className="mb-4">
              <span className="underline">
                Trade Ins and Program activity and participation.
              </span>{" "}
              We also collect personal data related to your participation in the
              Program, including your Trade Ins, appointments and related
              information and requests. For example, if you register for or
              change a Store Drop Off appointment, we collect your appointment
              details, contact preferences, and other information you provide
              related to your Trade In. When you request information or contact
              us about your Trade In, we collect and maintain records of your
              requests.
            </li>
            <li className="mb-4">
              <span className="underline">Surveys and feedback.</span> If you
              respond to or participate in surveys, focus groups, or other
              research projects or requests for feedback from or on LEGO's
              behalf, related to the Program, your responses and feedback will
              be collected and processed (including by Survey Administrator on
              behalf of LEGO).
            </li>
            <li className="mb-4">
              <span className="underline">
                Other communications and interactions.
              </span>{" "}
              When you otherwise communicate or interact with us related to the
              Program, whether through the Site, at Kiosks, in Stores, or via
              phone, email or otherwise, we collect and maintain a record of
              your contact details, contact preferences, communications, and our
              responses. For example, this may include transcripts or recordings
              of your chats, calls or other conversations with us, Program
              feedback and suggestions you provide, information about customer
              support or help requests, as well as information you provide
              through webforms on our Site, or when you elect to participate in
              a survey, focus group, or other research project or subscribe to
              informational or promotional emails from LEGO. We may also
              maintain records of communications and information that you post
              about the Program or submit to us on social media channels.
            </li>
          </ul>

          <h3 className="text-xl font-semibold mb-2">
            B. Personal Data We Derive or Collect Automatically.
          </h3>
          <p className="mb-4">
            We collect personal data related to your use of the Services,
            Program activities, and other interactions with us and others,
            including information we collect automatically (e.g., via cookies
            and pixels on the Site), as well as personal data we may derive
            about you and your use of the Services or Program activities. This
            includes:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-4">
              <span className="underline">
                Device and browsing information.
              </span>{" "}
              We use cookies, log files, pixel tags and other tracking
              technologies, including those provided by third parties, to
              automatically collect information when users access or use our
              Site or other Services online, such as IP address, domain name,
              page views, a date/time stamp, browser type, device type, device
              ID, Internet service provider, referring and exiting URLs,
              operating system, language, conversion and impression data related
              to our marketing and advertising campaigns, clickstream data, and
              similar device, activity and usage data. For more information, see{" "}
              <a
                href="#section-5-cookies"
                className="text-blue-600 hover:text-blue-800 underline"
              >
                Section 5. Cookies
              </a>{" "}
              below.
            </li>
            <li className="mb-4">
              <span className="underline">Location information.</span> We may
              collect or derive general location information about you through
              your IP address. Further, with your authorization, we may collect
              more precise geolocation information from you when you visit or
              use the Site through your device's browser-based geolocation
              prompt. Providing this information is optional. If you choose to
              provide this information, we will use it to tailor your experience
              on our Site to reflect your location and provide you with address
              information for participating Stores near you. If you do not
              provide us with your browser-based geo-location, we will not be
              able to provide you with this information. We do not collect your
              precise geolocation.
            </li>
            <li className="mb-4">
              <span className="underline">
                Program activities and other usage information.
              </span>{" "}
              We also collect and derive information about your Trade Ins,
              Program participation and activities, such as the actual vs.
              estimated weight for you Trade-Ins submitted by mail, how long it
              takes to submit or process a Trade In, and other transactional
              details related to your Trade Ins. We may also combine the
              personal data collected about you from different sources, to
              derive analytics, better understand Program participation, improve
              the Program and Services, and develop new features and services.
            </li>
          </ul>

          <h3 className="text-xl font-semibold mb-2">
            C. Personal Data from Other Sources.
          </h3>
          <p className="mb-6">
            We may also collect information about you from other sources, such
            as through our partners, processors and other third parties,
            including Pentatonic and Survey Administrator. For example, Survey
            Administrator may aggregate and analyze survey responses and other
            Program data they receive from or on behalf of LEGO in order to
            provide us with reports and analysis about the Program. We may also
            collect and receive analytics and attribution information related to
            our advertising and promotional content on other sites and social
            media platforms where we promote the Program (e.g., whether you came
            to our Site after viewing our ad on a third-party site). In
            addition, if you post information about the Program on social media,
            we may collect or receive information about your posts (subject to
            your preferences and the applicable terms of that social media
            platform).
          </p>

          <h2 className="text-2xl font-semibold mb-4">
            3. PURPOSES OF COLLECTION AND PROCESSING
          </h2>
          <p className="mb-6">
            In general, we use personal data for the purposes set forth below.
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-4">
              <span className="underline">
                Providing Services and Administering the Program.
              </span>{" "}
              To provide and operate our Site and Services, administer the
              Program, and communicate with you about the Program (e.g., your
              Trade Ins and your In-Store appointments), provide troubleshooting
              and technical support, respond to your inquiries and requests,
              process your Program requests, communicate with you, and for
              similar service and support purposes.
            </li>
            <li className="mb-4">
              <span className="underline">
                Communicating with you about the Services.
              </span>{" "}
              For example, to send notices, updates, security alerts and other
              transactional or administrative messages.
            </li>
            <li>
              <span className="underline">Analytics and improvement.</span> To
              better understand how data subjects access and use the Site and
              Services, participate in the Program, and for other research and
              analytical purposes, such as to evaluate and improve our services
              and business operations, to develop new services and features, and
              for internal quality control and training purposes.
            </li>
            <li className="mb-4">
              <span className="underline">
                Customization and personalization.
              </span>{" "}
              To tailor content we may send or display on the Services,
              including to offer location customization and personalized help
              and instructions, and to otherwise personalize your experiences.
            </li>
            <li>
              <span className="underline">
                Marketing and promotional purposes.
              </span>{" "}
              If you subscribe to receive informational and marketing emails, we
              may use your personal data to send you newsletters, updates,
              alerts, and promotional information we think may interest you, as
              well as to evaluate, measure, and improve our marketing.
            </li>
            <li>
              <span className="underline">Research and surveys.</span> To
              administer surveys and questionnaires, such as for market research
              or customer satisfaction purposes.
            </li>
            <li>
              <span className="underline">General business operations.</span> To
              consider and implement mergers, acquisitions, reorganizations, and
              other business transactions, and where necessary to the
              administration of our general business, accounting, recordkeeping,
              auditing, compliance, and legal functions.
            </li>
            <li className="mb-4">
              <span className="underline">
                Security and protection of rights.
              </span>{" "}
              To protect the Services and our business operations, including to
              prevent and detect fraud, misuse and unauthorized activities, as
              well as where we believe necessary to investigate, prevent or take
              action regarding illegal activities, suspected fraud, situations
              involving potential threats to the safety or legal rights of any
              person or third party, or violations of our Terms & Conditions or
              this Program Privacy Policy.
            </li>
            <li>
              <span className="underline">Defending our legal rights.</span> To
              manage and respond to actual and potential legal disputes and
              claims, and to otherwise establish, defend, or protect our legal
              rights or interests, including in the context of anticipated or
              actual litigation with users of our Site and/or Services or third
              parties.
            </li>
            <li className="mb-4">
              <span className="underline">
                Complying with legal obligations.
              </span>{" "}
              To comply with the law or legal proceedings. For example, we may
              disclose information in response to subpoenas, court order, and
              other lawful requests by regulators and law enforcement, including
              responding to national security or law enforcement disclosure
              requirements.
            </li>
          </ul>

          <p className="mb-6">
            <strong>Aggregate and Non-identifiable Data.</strong> We may
            collect, use, disclose, and otherwise process aggregate, anonymous,
            and other non-identifiable data related to our business and Services
            for quality control, analytics, marketing, advertising, research,
            development, compliance, or other purposes. Where we use, disclose
            or process data that has been de-identified data, we will maintain
            and use the information in de-identified form and not to attempt to
            reidentify the information, except pursuant to applicable privacy
            laws.
          </p>

          <h2 className="text-2xl font-semibold mb-4">
            4. DISCLOSURES AND DATA SHARING
          </h2>
          <p className="mb-6">
            We may disclose the information, including personal data, that we
            collect to others, as reasonably necessary for the purposes
            described above and as otherwise directed or authorized to by you,
            which may include:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-6">
              <span className="underline">LEGO Group and affiliates.</span> To
              effectively manage and operate the Program, certain personal data
              collected through Services will be shared with the LEGO Group and
              its affiliates. This data sharing is essential for processing your
              requests, managing the Program, and providing customer support.
              The shared data may include, but is not limited to, contact
              information, Program information, details of inquiries, Adobe
              Analytics data collected where cookies are enabled, and any other
              relevant information necessary for the effective operation of the
              Program. The LEGO Group will handle your personal data in
              compliance with applicable US data protection laws.
            </li>
            <li className="mb-6">
              <span className="underline">Partners.</span> We may disclose or
              make available certain personal data to our third party partners
              to enable us to provide the Services and administer the Program
              (e.g., to prepare shipping labels, track shipments, process Trade
              Ins, and otherwise administer the Program).
            </li>
            <li className="mb-6">
              <span className="underline">
                Processors, vendors and service providers.
              </span>{" "}
              To vendors, service providers, contractors, or agents who process
              your personal data on our behalf, in order to provide services to
              us or perform functions on our behalf, including for example,
              service providers, help desk, analytics providers, consultants,
              auditors and legal counsel.
            </li>
            <li className="mb-6">
              <span className="underline">
                Analytics and Measurement Services.
              </span>{" "}
              We may disclose certain information that includes personal data to
              third-party analytics providers (such as Adobe Analytics), who may
              use this data to analyze and improve the Services and Program and
              evaluate and improve the performance of our content and ads
              (including on third party sites). For more information, see{" "}
              <a
                href="#section-5-cookies"
                className="text-blue-600 hover:text-blue-800 underline"
              >
                Section 5. Cookies
              </a>
              , Analytics and Tracking, below.
            </li>
            <li className="mb-6">
              <span className="underline">
                Protecting rights and interests.
              </span>{" "}
              To law enforcement and others where we believe doing so is
              necessary to protect the Services, our rights and property, or the
              rights, property and safety of others. For example, in order to
              (i) prevent, detect, investigate and respond to fraud,
              unauthorized activities and access, illegal activities, and misuse
              of the Services, (ii) situations involving potential threats to
              the health, safety or legal rights of any person or third party,
              or (iii) enforce, and detect, investigate and respond to
              violations of our Terms & Conditions. We may also disclose
              personal data, related to litigation and other legal claims or
              proceedings in which we are involved, as well as for our internal
              accounting, auditing, compliance, recordkeeping, and legal
              functions.
            </li>
            <li className="mb-6">
              <span className="underline">Legal compliance.</span> To
              regulators, law enforcement and other third parties in order to
              comply with applicable legal or regulatory obligations, including
              as part of a judicial proceeding, in response to a subpoena,
              warrant, court order or other legal process, or as part of an
              investigation or request, whether formal or informal, from law
              enforcement or a government official.
            </li>
            <li>
              <span className="underline">Business transfers.</span> We may
              disclose your information to another entity in connection with an
              acquisition or merger, sale or transfer of a business unit or
              assets, bankruptcy proceeding, or as part of any other similar
              business transfer, including during negotiations related to such
              transactions.
            </li>
          </ul>

          <h2 id="section-5-cookies" className="text-2xl font-semibold mb-4">
            5. COOKIES, ANALYTICS AND TRACKING
          </h2>
          <p className="mb-6">
            We use cookies, pixels and similar tracking technologies, some of
            which are provided by third parties, to collect or transmit
            information about Services and your activities, interactions or
            usage of our Site, Services, and online content (including on third
            party sites and services). Cookies are small data files that your
            browser places on your computer or device. A cookie itself does not
            contain or collect information. However, when it is read by a server
            via a web browser, it can help a website or web application deliver
            a more user-friendly service—for example, remembering account
            details. Pixels are small files embedded invisibly on webpages and
            other online content. We may use these, in connection with our
            Services to, among other things, track Site activities, and help us
            manage content and compile usage statistics. We may also use these
            in HTML e-mails we send, to help us track e-mail response rates,
            identify when our e-mails are viewed, and track whether our e-mails
            are forwarded.
          </p>
          <p className="mb-6">
            Additional information about the third-party cookies and tracking
            technologies we may use and the choices you have about the use of
            cookies on our Site, is provided below.
          </p>

          <h3 className="text-xl font-semibold mb-2">
            Third-Party Analytics and Tools:
          </h3>
          <p className="mb-6">
            We use third-party tools, such as Adobe Analytics, which are
            operated by third-party companies. These third-party analytics
            companies may collect usage data (using cookies, pixels and similar
            tools) about our Services in order to provide us with reports and
            metrics that help us to evaluate usage of our Services and improve
            performance and user experiences. You can also object to the
            collection of data that is generated by Adobe Analytics, which is
            related to the use of this Site, as well as the processing of this
            data by Adobe. For this purpose, the data subject must download a
            browser add-on at{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.adobe.com/privacy/opt-out.html"
              className="text-blue underline"
            >
              https://www.adobe.com/privacy/opt-out.html
            </a>{" "}
            and install it. Further information and the applicable data
            protection provisions of Adobe may be retrieved at{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.adobe.com/privacy.html"
              className="text-blue underline"
            >
              https://www.adobe.com/privacy.html
            </a>{" "}
            and at{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.adobe.com/legal/terms.html"
              className="text-blue underline"
            >
              https://www.adobe.com/legal/terms.html
            </a>
            . Adobe Analytics is further explained at{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.adobe.com/analytics/adobe-analytics.html"
              className="text-blue underline"
            >
              https://www.adobe.com/analytics/adobe-analytics.html
            </a>
          </p>

          <h3 className="text-xl font-semibold mb-2">Targeted Advertising:</h3>
          <p className="mb-6">
            We work with third parties, such as ad networks, channel partners,
            mobile ad networks, analytics and measurement services and others ("
            <strong>third-party ad companies</strong>") to manage our
            advertising on third-party sites, apps and online services. We may
            share certain information with these third-party ad companies, and
            we and them may use cookies, pixels tags, and other tools to collect
            usage and browsing information within our Services, as well as on
            third-party sites, apps and services, such as IP address, location
            information, device ID, cookie and advertising IDs, and other
            identifiers, as well as browsing information. We and these
            third-party ad companies use this information to provide you more
            relevant ads and content on third-party sites and apps, and to
            evaluate the success of such ads and content.
          </p>

          <h3 className="text-xl font-semibold mb-2">
            Additional Information and Choices:
          </h3>
          <p className="mb-6">
            For more information about cookies and how to manage them, please
            read our full{" "}
            <Link
              target="_blank"
              to={t("urls.cookie_policy")}
              className="text-blue underline cursor-pointer"
            >
              Cookie Policy
            </Link>{" "}
            and{" "}
            <Link
              target="_blank"
              to={t("urls.cookie_declaration")}
              className="text-blue underline cursor-pointer"
            >
              Cookie Declaration
            </Link>{" "}
            . You can review or change your preferences for most cookies on our
            Site (other than those that are necessary to the performance,
            operation, or security of our Site) as follows:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-4">
              <strong>Cookie preference manager.</strong> You can review or
              change your preferences for targeting cookies and tags on our Site
              by adjusting your cookie settings in our{" "}
              <span className="cky-banner-element text-blue-600 hover:text-blue-800 underline">
                cookie preference
              </span>{" "}
              manager.
            </li>
            <li>
              <strong>Universal browser signals.</strong> Our Site recognizes
              global privacy control—or 'GPC'—signals and applies these to opt
              you out of third-party cookies that are not necessary to the
              performance, operation, or security of our Site. You can find more
              information on GPC signals at{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.globalprivacycontrol.org"
                className="text-blue underline"
              >
                www.globalprivacycontrol.org
              </a>
              . (<strong>Please note</strong>: currently, our Site does not
              recognize browser "do-not-track" requests).
            </li>
          </ul>
          <p className="mb-6">
            You can also use certain industry ad choice tools to control how
            participating third-party ad companies use the information that they
            collect about your visits to our Site and those of third parties.
            For more information and to opt out of collection for targeted
            advertising from participating third-party ad networks go to{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://aboutads.info/choices"
              className="text-blue underline"
            >
              https://aboutads.info/choices
            </a>{" "}
            (Digital Advertising Alliance). You can also download the DAA
            AppChoices tool in order to help control interest-based advertising
            on apps on your mobile device. Please note that opting out of
            participating ad networks does not opt you out of being served
            advertising. You may continue to receive generic or contextual ads
            on our Services. You may also continue to receive targeted ads on
            other websites, from companies that do not participate in the above
            programs.
          </p>
          <p className="mb-6">
            You can also set your browser to block certain cookies or notify you
            when a cookie is set. The Help portion of the toolbar on most
            browsers will tell you how to prevent your device from accepting new
            cookies, how to have the browser notify you when you receive a new
            cookie, or how to disable cookies altogether. Visitors to our Site
            and Services who disable cookies will be able to browse the Site,
            but some features may not function.
          </p>

          <h2 className="text-2xl font-semibold mb-4">
            6. PRIVACY RIGHTS AND CHOICES
          </h2>
          <p className="mb-6">
            Users have several choices regarding their personal data and privacy
            preferences, as described in this section.
          </p>

          <h3 className="text-xl font-semibold mb-2">
            Review and Update Information:
          </h3>
          <p className="mb-6">
            You may review and update much of the personal data that you have
            submitted by logging into your account and updating your profile
            information. Please note that we may maintain copies of information
            that you have updated, modified, or deleted, as permitted, in our
            business records and in the normal course of our business
            operations, as permitted or required by applicable law.
          </p>

          <h3 className="text-xl font-semibold mb-2">
            Marketing Communications:
          </h3>
          <p className="mb-6">
            You may opt out of marketing and promotional emails from us by
            following the opt-out instructions contained in the email. Please
            note that it may take up to ten (10) business days for us to process
            opt out requests. If you opt out, we may still send you
            transactional and administrative emails about your account, Trade
            Ins, appointments or other Program requests.
          </p>

          <h3 className="text-xl font-semibold mb-2">Cookie Preferences:</h3>
          <p className="mb-6">
            As described in{" "}
            <a
              href="#section-5-cookies"
              className="text-blue-600 hover:text-blue-800 underline"
            >
              Section 5. Cookies
            </a>{" "}
            above, you can manage your preferences for cookies and pixels on our
            Site by adjusting your cookie settings{" "}
            <span className="text-blue-600 hover:text-blue-800 underline cky-banner-element">
              here
            </span>
            .
          </p>

          <h3 className="text-xl font-semibold mb-2">State Privacy Rights:</h3>
          <p className="mb-6">
            Some state consumer privacy laws give residents of their respective
            states certain privacy rights regarding their personal data, which
            include the following rights, subject to certain exceptions and
            restrictions:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-4">
              <span className="underline">To Correct.</span> The right to
              correct inaccuracies in their personal data, taking into account
              the nature and purposes of the processing of the personal data.
            </li>
            <li className="mb-4">
              <span className="underline">To Delete.</span> The right to delete
              their personal data provided to or obtained by us.
            </li>
            <li className="mb-4">
              <span className="underline">To Access or Know.</span> The right to
              confirm whether we are processing their personal data and to
              obtain certain information about our collect, use, disclosure and
              processing, as well a copy of their personal data in a portable
              and, to the extent technically feasible, readily usable format
              (referred to as a "request to know" under the California Consumer
              Privacy Act (CCPA)).
            </li>
            <li className="mb-4">
              <span className="underline">To Opt-Out.</span> The right to opt
              out of or limit certain types of processing, including:
              <ul className="list-disc pl-6 mt-2">
                <li className="mb-2">
                  To opt out of the "sale" of their personal data. We do not
                  sell, disclose or make available your personal data to third
                  parties in exchange for monetary consideration. However,
                  disclosing and making certain data (such as IP address and
                  online identifiers, browsing and activity information, and
                  interests) via third-party cookies and pixels on our Site may
                  be considered a 'sale' under applicable state privacy laws.
                </li>
                <li className="mb-2">
                  To opt out of targeted advertising by us (referred to as
                  "sharing" under the CCPA), including via cookies on our Site.
                </li>
                <li className="mb-2">
                  To opt out of any processing of personal data for purposes of
                  making decisions that produce legal or similarly significant
                  effects. However, we do not use your data for profiling
                  purposes or automatic decision-making.
                </li>
                <li>
                  To opt out or limit the collection and disclosure of their
                  sensitive personal data. We generally only collect your
                  sensitive personal data with your consent and will only use
                  this information in order to respond to your requests,
                  administer your Trade Ins, or comply with the law, or protect
                  and defend our legal rights, prevent and respond to fraudulent
                  or unauthorized activities, or for security purposes, as
                  permitted by applicable privacy laws.
                </li>
              </ul>
            </li>
            <li className="mb-4">
              <span className="underline">To Appeal.</span> The right to appeal
              our denial of your privacy request.
            </li>
          </ul>
          <p className="mb-6">
            We will not discriminate against individuals for exercising their
            privacy rights.
          </p>

          <h3 className="text-xl font-semibold mb-2">
            Submitting Privacy Requests:
          </h3>
          <p className="mb-6">
            You may submit a privacy request, including to access, correct,
            delete, or opt out, or limit or object to certain uses and
            disclosures of your personal data (to the extent applicable) by:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li>
              Emailing us at{" "}
              <a
                href="mailto:support@legobricktakeback.com"
                className="text-blue-600 hover:text-blue-800 underline"
              >
                support@LEGOBrickTakeBack.com
              </a>
            </li>
            <li>Contacting us at 1-800-835-4386 (toll free)</li>
          </ul>
          <p className="mb-6">
            You can also opt out of any 'sales' and 'sharing' via cookies on our
            Site as set forth above, in Section 5. Cookies, Analytics and
            Tracking.
          </p>
          <p className="mb-6">
            We will process privacy rights requests in accordance with
            applicable privacy laws. We may request additional information about
            your requests, where needed to verify your identity or otherwise
            process your request. You can find additional information about
            these privacy rights and how LEGO receives and processes your
            requests in the{" "}
            <a
              href="https://www.lego.com/en-us/legal/notices-and-policies/privacy-policy?locale=en-us"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 underline"
            >
              LEGO Privacy Policy
            </a>
            .
          </p>

          <h3 className="text-xl font-semibold mb-2">
            California Privacy Rights:
          </h3>
          <p className="mb-6">
            If you are a California resident, please review{" "}
            <a
              href="https://www.lego.com/cdn/cs/legal/assets/blted9652e4eb78b865/LEGO_CCPA_Nov_10.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 underline"
            >
              IMPORTANT ADDITIONAL INFORMATION FOR CALIFORNIA RESIDENTS
            </a>{" "}
            for additional information about your California privacy rights,
            including your right to opt out of sales and sharing under the CCPA.
          </p>
          <p className="mb-6">
            For more information about our privacy practices and your privacy
            choices, you may contact us as set forth in the 'Contact Us' section
            below.
          </p>

          <h2 className="text-2xl font-semibold mb-4">
            7. PERIOD FOR WHICH PERSONAL DATA ARE STORED
          </h2>
          <p className="mb-6">
            We process and store the personal data of the data subject only for
            the period necessary to achieve the purpose of storage, or as long
            as is required by applicable US laws and regulations.
          </p>
          <p className="mb-6">
            If the storage purpose is fulfilled, or if a storage period
            prescribed by applicable US laws expires, the personal data is
            routinely blocked or erased in accordance with legal requirements.
            Data sent in connection with requests sent to us via our web
            application are deleted once the purpose of the communication is
            fulfilled. Our right to retain data for a longer period in
            accordance with legal retention periods or due to potential disputes
            remains unaffected.
          </p>

          <h2 className="text-2xl font-semibold mb-4">
            8. CHANGES TO PROGRAM PRIVACY POLICY
          </h2>
          <p className="mb-6">
            This Program Privacy Policy is current as of the Effective Date set
            forth above. We may change this Program Privacy Policy from time to
            time, so please be sure to check back periodically. We will post any
            changes to this Policy on our Site. If we make any changes to this
            Program Privacy Policy that materially affect our practices with
            regard to the personal data we have previously collected from you,
            we will endeavor to provide you with notice in advance of such
            change, such as via email or prominent notice on the Site.
          </p>

          <h2 className="text-2xl font-semibold mb-4">9. CONTACT US</h2>
          <p className="mb-6">
            If you have questions or concerns regarding the way in which your
            personal data is being processed or this Program Privacy Policy,
            please reach out to us using the contact information below:
          </p>
          <p className="mb-6">
            LEGO Systems Inc.
            <br />
            <br />
            100 Print Shop Road
            <br />
            Enfield, CT 06082
            <br />
            United States
            <br />
            <br />
            <span className="font-bold">Mailing address:</span> <br />
            P.O. Box 1138
            <br />
            Enfield, CT 06083-1138
            <br />
            United States of America
            <br />
            <br /> Email:{" "}
            <a
              href="mailto:support@legobricktakeback.com"
              className="text-blue underline"
            >
              support@LEGOBrickTakeBack.com
            </a>
          </p>
        </div>
      </div>
      <Footer />
      {/* <ImpressumFooter /> */}
    </div>
  );
}
